export default "__VITE_ASSET__DAdSU07e__"